import { render, staticRenderFns } from "./drag-icon.vue?vue&type=template&id=24a28802&"
import script from "./drag-icon.vue?vue&type=script&lang=js&"
export * from "./drag-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports